<template>
  <div class="main-layout">
    <header class="main-layout__header">
      <div class="container">
        <img class="gob-band-icon" src="@/assets/images/gob-band.svg" alt="Gob Band">
        <div class="main-layout__header-bottom">
          <div class="main-layout__header-bottom-left">
            <router-link to="/" tag="h1" class="main-layout__title">
              <strong>Dispensación de</strong> Medicamentos
            </router-link>
            <app-date-time :user="user" />
          </div>
          <div class="main-layout__header-bottom-right">
            <div class="row">
              <div class="col-md-8">
                <auth-user-info :user="user" :active-organization="activeOrganization" />
              </div>
              <div class="col-md-4 pt-4">
                <div style="width:200px;margin-bottom:20px;">
                  <router-link to="/auth/logout" class="logout-btn">
                    <i class="fas fa-power-off mr-2" aria-hidden="true" />Cerrar sesión
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <main class="main-layout__content container">
      <div class="back-btn" :class="{visible: this.$route.name !== 'home'}" @click="$router.push(backButtonPath)">
        <i class="fas fa-arrow-left" aria-hidden="true" />
        Atrás
      </div>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </main>
    <footer class="main-layout__footer">
      <div class="container">
        <span class="main-layout__footer-logo">&nbsp;</span>
      </div>
    </footer>
    <el-dialog
      title="Seleccione la farmacia"
      :visible="!activeOrganization"
      :show-close="false"
      width="80%"
      class="organization-picker-dialog">
      <auth-organization-picker :user="user" @select-organization="handleSelectOrganization" />
    </el-dialog>
    <!-- <logout-modal /> -->
    <logout-modal-new />
  </div>
</template>

<script>
import AuthUserInfo from '../components/auth/AuthUserInfo';
import AuthOrganizationPicker from '@/components/auth/AuthOrganizationPicker';
import _get from 'lodash/get';
import LogoutModalNew from '@/components/LogoutModalNew';

import AppDateTime from '@/components/AppDateTime';

import localStorage from '@/helpers/localStorage';

localStorage.initialize();

export default {
  name: 'MainLayout',
  components: {
    AuthOrganizationPicker,
    AuthUserInfo,
    AppDateTime,
    LogoutModalNew
  },
  data() {
    return {
      showOrganizationPicker: false
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    activeOrganization() {
      return this.$store.getters.activeOrganization;
    },
    backButtonPath() {
      return _get(this.$route, 'meta.backButtonPath', '/');
    }
  },
  watch: {
    activeOrganization: {
      immediate: true,
      handler(activeOrganization) {
        if (!activeOrganization) {
          this.showOrganizationPicker = true;
        }
      }
    },
    $route(to, from) {
      if (this.$store.getters.loggedIn) {
        this.$store.dispatch('checkToken').catch((e) => { this.$store.dispatch('logout', e); });
      }
    }
  },
  methods: {
    handleSelectOrganization(organizationUuid) {
      this.$store.dispatch('setActiveOrganizationUuid', organizationUuid);
    }
  }
};
</script>

<style lang="scss">
.main-layout {
  display: grid;
  grid-template-areas:
    "header"
    "content"
    "footer";
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  min-height: 100vh;
  background-color: $--app-main-bg-color;

  .gob-band-icon {
    position: absolute;
  }

  &__header {
    grid-area: header;
    background-color: $--app-header-bg-color;
  }

  &__header-bottom {
    color: $--color-white;
    display: block;
    justify-content: space-between;
    align-items: baseline;
    @media (min-width: map-get($--grid-breakpoints, "md")) {
      display: flex;
    }
  }

  &__header-bottom-right {
    display: flex;
    align-items: baseline;

    .auth-user-info {
      margin-right: $--spacing-4;
    }
  }

  &__title {
    color: $--color-white;
    font-size: $--font-size-lg;
    padding: $--spacing-6 0;
    cursor: pointer;
  }

  &__content {
    grid-area: content;
  }

  &__footer {
    grid-area: footer;
    padding: $--spacing-6 0;

    .container {
      display: flex;
      justify-content: center;
    }
  }

  &__footer-logo {
    width: 200px;
    display: block;
  }
}
.back-btn {
  opacity: 0;
  color: #fff;
  height: 52px;
  cursor: pointer;
  padding: 15px 0;
  display: inline-block;
  pointer-events: none;
  transition: .2s;
  &.visible {
    opacity: 1;
    pointer-events: auto;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
